var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainbowSwatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 264.58 264.58",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 132.29,
    cy: 164.71,
    r: 132.29,
    gradientTransform: "translate(-1.913e-6 5.4754e-6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -32.417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m131.14 32.422a132.29 132.29 0 0 1 2.5398 0.0022l-1.3853 132.28z",
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.45 32.422a132.29 132.29 0 0 1 2.5394 0.04654l-3.6938 132.24z",
    fill: "#ff0400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.75 32.462a132.29 132.29 0 0 1 2.5382 0.09085l-6.0011 132.16z",
    fill: "#ff0900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.06 32.543a132.29 132.29 0 0 1 2.5362 0.13514l-8.3067 132.03z",
    fill: "#ff0d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.37 32.663a132.29 132.29 0 0 1 2.5334 0.17938l-10.61 131.87z",
    fill: "#f10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.67 32.824a132.29 132.29 0 0 1 2.5299 0.22356l-12.909 131.66z",
    fill: "#ff1500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.97 33.026a132.29 132.29 0 0 1 2.5256 0.26768l-15.205 131.41z",
    fill: "#ff1a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.27 33.267a132.29 132.29 0 0 1 2.5206 0.31172l-17.496 131.13z",
    fill: "#ff1e00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.56 33.548a132.29 132.29 0 0 1 2.5148 0.35566l-19.782 130.8z",
    fill: "#f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.85 33.87a132.29 132.29 0 0 1 2.5082 0.3995l-22.062 130.44z",
    fill: "#ff2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.13 34.231a132.29 132.29 0 0 1 2.5008 0.44321l-24.335 130.03z",
    fill: "#ff2b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.4 34.632a132.29 132.29 0 0 1 2.4927 0.48679l-26.601 129.59z",
    fill: "#ff2f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.67 35.072a132.29 132.29 0 0 1 2.4838 0.53022l-28.859 129.11z",
    fill: "#f30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.92 35.552a132.29 132.29 0 0 1 2.4742 0.57349l-31.107 128.58z",
    fill: "#ff3700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.17 36.072a132.29 132.29 0 0 1 2.4638 0.61658l-33.347 128.02z",
    fill: "#ff3c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.41 36.63a132.29 132.29 0 0 1 2.4527 0.65948l-35.576 127.42z",
    fill: "#ff4000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.65 37.228a132.29 132.29 0 0 1 2.4408 0.70219l-37.794 126.78z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.65 37.228a132.29 132.29 0 0 1 2.4408 0.70219l-37.794 126.78z",
    fill: "#f40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.86 37.864a132.29 132.29 0 0 1 2.4282 0.74468l-40.001 126.1z",
    fill: "#ff4800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.07 38.54a132.29 132.29 0 0 1 2.4148 0.78694l-42.196 125.38z",
    fill: "#ff4d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.27 39.253a132.29 132.29 0 0 1 2.4007 0.82896l-44.377 124.63z",
    fill: "#ff5100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.45 40.005a132.29 132.29 0 0 1 2.3858 0.87074l-46.546 123.83z",
    fill: "#f50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.62 40.794a132.29 132.29 0 0 1 2.3703 0.91224l-48.7 123z",
    fill: "#ff5900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.78 41.622a132.29 132.29 0 0 1 2.354 0.95347l-50.839 122.13z",
    fill: "#ff5e00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.92 42.487a132.29 132.29 0 0 1 2.337 0.99441l-52.963 121.23z",
    fill: "#ff6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.04 43.389a132.29 132.29 0 0 1 2.3193 1.035l-55.07 120.28z",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.15 44.328a132.29 132.29 0 0 1 2.3009 1.0754l-57.161 119.3z",
    fill: "#ff6a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.24 45.304a132.29 132.29 0 0 1 2.2818 1.1154l-59.235 118.29z",
    fill: "#ff6f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.32 46.316a132.29 132.29 0 0 1 2.262 1.155l-61.29 117.24z",
    fill: "#ff7300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.38 47.364a132.29 132.29 0 0 1 2.2414 1.1943l-63.327 116.15z",
    fill: "#f70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.42 48.448a132.29 132.29 0 0 1 2.2203 1.2332l-65.344 115.03z",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.44 49.568a132.29 132.29 0 0 1 2.1984 1.2718l-67.342 113.87z",
    fill: "#ff8000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.43 50.722a132.29 132.29 0 0 1 2.1759 1.31l-69.319 112.68z",
    fill: "#ff8400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.41 51.911a132.29 132.29 0 0 1 2.1527 1.3478l-71.275 111.45z",
    fill: "#f80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.37 53.135a132.29 132.29 0 0 1 2.1288 1.3851l-73.209 110.19z",
    fill: "#ff8c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.31 54.392a132.29 132.29 0 0 1 2.1043 1.4221l-75.121 108.89z",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.22 55.683a132.29 132.29 0 0 1 2.0792 1.4586l-77.01 107.57z",
    fill: "#ff9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.11 57.008a132.29 132.29 0 0 1 2.0534 1.4946l-78.876 106.21z",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.98 58.365a132.29 132.29 0 0 1 2.027 1.5302l-80.717 104.81z",
    fill: "#ff9d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.83 59.754a132.29 132.29 0 0 1 2 1.5654l-82.534 103.39z",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.65 61.176a132.29 132.29 0 0 1 1.9724 1.6001l-84.326 101.93z",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.44 62.629a132.29 132.29 0 0 1 1.9442 1.6342l-86.092 100.45z",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.21 64.113a132.29 132.29 0 0 1 1.9153 1.6679l-87.832 98.927z",
    fill: "#ffae00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.95 65.628a132.29 132.29 0 0 1 1.8859 1.7011l-89.545 97.38z",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.67 67.173a132.29 132.29 0 0 1 1.856 1.7337l-91.231 95.802z",
    fill: "#ffb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.36 68.747a132.29 132.29 0 0 1 1.8254 1.7659l-92.889 94.195z",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.36 68.747a132.29 132.29 0 0 1 1.8254 1.7659l-92.889 94.195z",
    fill: "#fb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.02 70.351a132.29 132.29 0 0 1 1.7943 1.7975l-94.519 92.56z",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.65 71.984a132.29 132.29 0 0 1 1.7627 1.8285l-96.12 90.896z",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.25 73.645a132.29 132.29 0 0 1 1.7305 1.859l-97.691 89.205z",
    fill: "#ffc800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.83 75.333a132.29 132.29 0 0 1 1.6978 1.8889l-99.233 87.486z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.37 77.049a132.29 132.29 0 0 1 1.6646 1.9182l-100.75 85.741z",
    fill: "#ffd000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.89 78.792a132.29 132.29 0 0 1 1.6308 1.947l-102.23 83.97z",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.37 80.56a132.29 132.29 0 0 1 1.5966 1.9752l-103.68 82.173z",
    fill: "#ffd900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.82 82.355a132.29 132.29 0 0 1 1.5619 2.0027l-105.09 80.351z",
    fill: "#fd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.25 84.174a132.29 132.29 0 0 1 1.5267 2.0297l-106.48 78.504z",
    fill: "#ffe100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.64 86.018a132.29 132.29 0 0 1 1.491 2.056l-107.83 76.634z",
    fill: "#ffe600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.99 87.886a132.29 132.29 0 0 1 1.4549 2.0817l-109.16 74.74z",
    fill: "#ffea00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.32 89.777a132.29 132.29 0 0 1 1.4184 2.1068l-110.44 72.824z",
    fill: "#fe0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.61 91.692a132.29 132.29 0 0 1 1.3814 2.1312l-111.7 70.885z",
    fill: "#fff200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.87 93.628a132.29 132.29 0 0 1 1.344 2.155l-112.92 68.925z",
    fill: "#fff700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.09 95.586a132.29 132.29 0 0 1 1.3062 2.1782l-114.1 66.944z",
    fill: "#fffb00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.28 97.565a132.29 132.29 0 0 1 1.268 2.2006l-115.25 64.942z",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.43 99.565a132.29 132.29 0 0 1 1.2294 2.2224l-116.37 62.921z",
    fill: "#fbff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.55 101.58a132.29 132.29 0 0 1 1.1904 2.2435l-117.45 60.881z",
    fill: "#f7ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.64 103.62a132.29 132.29 0 0 1 1.1511 2.264l-118.5 58.822z",
    fill: "#f2ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.68 105.68a132.29 132.29 0 0 1 1.1114 2.2837l-119.5 56.745z",
    fill: "#ef0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.7 107.76a132.29 132.29 0 0 1 1.0714 2.3028l-120.48 54.65z",
    fill: "#eaff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.67 109.85a132.29 132.29 0 0 1 1.031 2.3211l-121.41 52.539z",
    fill: "#e6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.61 111.96a132.29 132.29 0 0 1 0.99033 2.3388l-122.31 50.412z",
    fill: "#e1ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.51 114.08a132.29 132.29 0 0 1 0.94936 2.3557l-123.17 48.27z",
    fill: "#df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.38 116.22a132.29 132.29 0 0 1 0.9081 2.3719l-123.99 46.113z",
    fill: "#d9ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.21 118.38a132.29 132.29 0 0 1 0.86657 2.3874l-124.78 43.942z",
    fill: "#d5ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257 120.55a132.29 132.29 0 0 1 0.82477 2.4021l-125.53 41.758z",
    fill: "#d0ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.75 122.73a132.29 132.29 0 0 1 0.78273 2.4162l-126.24 39.561z",
    fill: "#cf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.46 124.93a132.29 132.29 0 0 1 0.74044 2.4294l-126.91 37.351z",
    fill: "#c8ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.14 127.14a132.29 132.29 0 0 1 0.69792 2.442l-127.54 35.131z",
    fill: "#c4ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.77 129.35a132.29 132.29 0 0 1 0.6552 2.4538l-128.14 32.9z",
    fill: "#bfff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.37 131.59a132.29 132.29 0 0 1 0.61228 2.4649l-128.69 30.658z",
    fill: "#bf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.93 133.83a132.29 132.29 0 0 1 0.56916 2.4752l-129.21 28.408z",
    fill: "#b7ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.45 136.08a132.29 132.29 0 0 1 0.52588 2.4847l-129.68 26.148z",
    fill: "#b3ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.93 138.33a132.29 132.29 0 0 1 0.48244 2.4935l-130.12 23.881z",
    fill: "#aeff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.37 140.6a132.29 132.29 0 0 1 0.43884 2.5016l-130.52 21.607z",
    fill: "#af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.77 142.87a132.29 132.29 0 0 1 0.39512 2.5089l-130.87 19.326z",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.13 145.15a132.29 132.29 0 0 1 0.35128 2.5154l-131.19 17.039z",
    fill: "#a2ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.45 147.44a132.29 132.29 0 0 1 0.30732 2.5211l-131.47 14.746z",
    fill: "#9eff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.73 149.73a132.29 132.29 0 0 1 0.26328 2.5261l-131.7 12.45z",
    fill: "#9f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.97 152.03a132.29 132.29 0 0 1 0.21915 2.5303l-131.9 10.149z",
    fill: "#95ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.18 154.33a132.29 132.29 0 0 1 0.17496 2.5338l-132.06 7.8457z",
    fill: "#91ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.34 156.63a132.29 132.29 0 0 1 0.13071 2.5364l-132.18 5.5398z",
    fill: "#8cff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.46 158.94a132.29 132.29 0 0 1 0.0864 2.5383l-132.25 3.2322z",
    fill: "#8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.54 161.25a132.29 132.29 0 0 1 0.0421 2.5394l-132.29 0.92356z",
    fill: "#84ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.58 163.55a132.29 132.29 0 0 1-2e-3 2.5398l-132.28-1.3853z",
    fill: "#80ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.58 165.86a132.29 132.29 0 0 1-0.0465 2.5394l-132.24-3.6938z",
    fill: "#7bff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.54 168.17a132.29 132.29 0 0 1-0.0908 2.5382l-132.16-6.0011z",
    fill: "#7f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.46 170.48a132.29 132.29 0 0 1-0.13513 2.5362l-132.03-8.3067z",
    fill: "#73ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.34 172.78a132.29 132.29 0 0 1-0.17937 2.5334l-131.87-10.61z",
    fill: "#6fff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.18 175.09a132.29 132.29 0 0 1-0.22356 2.5299l-131.66-12.909z",
    fill: "#6aff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.97 177.39a132.29 132.29 0 0 1-0.26768 2.5256l-131.41-15.205z",
    fill: "#6f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.73 179.68a132.29 132.29 0 0 1-0.31172 2.5206l-131.13-17.496z",
    fill: "#62ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.45 181.98a132.29 132.29 0 0 1-0.35566 2.5148l-130.8-19.782z",
    fill: "#5eff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.13 184.26a132.29 132.29 0 0 1-0.39949 2.5082l-130.44-22.062z",
    fill: "#59ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.77 186.54a132.29 132.29 0 0 1-0.44321 2.5008l-130.03-24.335z",
    fill: "#5f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.37 188.82a132.29 132.29 0 0 1-0.48679 2.4927l-129.59-26.601z",
    fill: "#51ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.93 191.08a132.29 132.29 0 0 1-0.53022 2.4838l-129.11-28.859z",
    fill: "#4dff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.45 193.34a132.29 132.29 0 0 1-0.57348 2.4742l-128.58-31.107z",
    fill: "#48ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.93 195.59a132.29 132.29 0 0 1-0.61657 2.4638l-128.02-33.347z",
    fill: "#4f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.37 197.83a132.29 132.29 0 0 1-0.65948 2.4527l-127.42-35.576z",
    fill: "#40ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.77 200.06a132.29 132.29 0 0 1-0.70219 2.4408l-126.78-37.794z",
    fill: "#3cff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.14 202.28a132.29 132.29 0 0 1-0.74468 2.4282l-126.1-40.001z",
    fill: "#37ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.46 204.49a132.29 132.29 0 0 1-0.78694 2.4148l-125.38-42.196z",
    fill: "#3f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.75 206.69a132.29 132.29 0 0 1-0.82896 2.4007l-124.63-44.377z",
    fill: "#2fff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257 208.87a132.29 132.29 0 0 1-0.87074 2.3858l-123.83-46.546z",
    fill: "#2bff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.21 211.04a132.29 132.29 0 0 1-0.91224 2.3703l-123-48.7z",
    fill: "#26ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.38 213.19a132.29 132.29 0 0 1-0.95348 2.354l-122.13-50.839z",
    fill: "#2f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.51 215.33a132.29 132.29 0 0 1-0.99441 2.337l-121.23-52.963z",
    fill: "#1eff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.61 217.46a132.29 132.29 0 0 1-1.035 2.3193l-120.28-55.07z",
    fill: "#1aff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.67 219.57a132.29 132.29 0 0 1-1.0754 2.3009l-119.3-57.161z",
    fill: "#15ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.7 221.66a132.29 132.29 0 0 1-1.1154 2.2818l-118.29-59.235z",
    fill: "#1f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.68 223.74a132.29 132.29 0 0 1-1.155 2.262l-117.24-61.29z",
    fill: "#0dff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.64 225.79a132.29 132.29 0 0 1-1.1943 2.2414l-116.15-63.327z",
    fill: "#09ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.55 227.83a132.29 132.29 0 0 1-1.2332 2.2203l-115.03-65.344z",
    fill: "#04ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.43 229.85a132.29 132.29 0 0 1-1.2718 2.1984l-113.87-67.342z",
    fill: "#0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.28 231.85a132.29 132.29 0 0 1-1.31 2.1759l-112.68-69.319z",
    fill: "#00ff04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.09 233.83a132.29 132.29 0 0 1-1.3478 2.1527l-111.45-71.275z",
    fill: "#00ff09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.87 235.79a132.29 132.29 0 0 1-1.3851 2.1288l-110.19-73.209z",
    fill: "#00ff0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.61 237.72a132.29 132.29 0 0 1-1.4221 2.1043l-108.89-75.121z",
    fill: "#0f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.32 239.64a132.29 132.29 0 0 1-1.4586 2.0792l-107.57-77.01z",
    fill: "#00ff15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.99 241.53a132.29 132.29 0 0 1-1.4946 2.0534l-106.21-78.876z",
    fill: "#00ff1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.64 243.4a132.29 132.29 0 0 1-1.5302 2.027l-104.81-80.717z",
    fill: "#00ff1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.25 245.24a132.29 132.29 0 0 1-1.5654 2l-103.39-82.534z",
    fill: "#0f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.82 247.06a132.29 132.29 0 0 1-1.6 1.9724l-101.93-84.326z",
    fill: "#00ff26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.37 248.86a132.29 132.29 0 0 1-1.6342 1.9442l-100.45-86.092z",
    fill: "#00ff2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.89 250.62a132.29 132.29 0 0 1-1.6679 1.9153l-98.927-87.832z",
    fill: "#00ff2f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.37 252.37a132.29 132.29 0 0 1-1.7011 1.8859l-97.38-89.545z",
    fill: "#0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.83 254.08a132.29 132.29 0 0 1-1.7337 1.856l-95.802-91.231z",
    fill: "#00ff37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.25 255.77a132.29 132.29 0 0 1-1.7659 1.8254l-94.195-92.889z",
    fill: "#00ff3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.65 257.43a132.29 132.29 0 0 1-1.7975 1.7943l-92.56-94.519z",
    fill: "#00ff40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.02 259.07a132.29 132.29 0 0 1-1.8285 1.7627l-90.896-96.12z",
    fill: "#0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.36 260.67a132.29 132.29 0 0 1-1.859 1.7305l-89.205-97.691z",
    fill: "#00ff48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.67 262.24a132.29 132.29 0 0 1-1.8889 1.6978l-87.486-99.233z",
    fill: "#00ff4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.95 263.79a132.29 132.29 0 0 1-1.9182 1.6646l-85.741-100.75z",
    fill: "#00ff51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.21 265.3a132.29 132.29 0 0 1-1.947 1.6308l-83.97-102.23z",
    fill: "#0f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.44 266.79a132.29 132.29 0 0 1-1.9752 1.5966l-82.173-103.68z",
    fill: "#00ff59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.65 268.24a132.29 132.29 0 0 1-2.0027 1.5619l-80.351-105.09z",
    fill: "#00ff5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.83 269.66a132.29 132.29 0 0 1-2.0297 1.5267l-78.504-106.48z",
    fill: "#00ff62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.98 271.05a132.29 132.29 0 0 1-2.056 1.491l-76.634-107.83z",
    fill: "#0f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.11 272.41a132.29 132.29 0 0 1-2.0817 1.4549l-74.74-109.16z",
    fill: "#00ff6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.22 273.73a132.29 132.29 0 0 1-2.1068 1.4184l-72.824-110.44z",
    fill: "#00ff6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.31 275.02a132.29 132.29 0 0 1-2.1312 1.3814l-70.885-111.7z",
    fill: "#00ff73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.37 276.28a132.29 132.29 0 0 1-2.155 1.344l-68.925-112.92z",
    fill: "#0f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.41 277.51a132.29 132.29 0 0 1-2.1782 1.3062l-66.944-114.1z",
    fill: "#00ff7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.43 278.69a132.29 132.29 0 0 1-2.2006 1.268l-64.942-115.25z",
    fill: "#00ff80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.44 279.85a132.29 132.29 0 0 1-2.2224 1.2294l-62.921-116.37z",
    fill: "#00ff84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.42 280.97a132.29 132.29 0 0 1-2.2435 1.1904l-60.881-117.45z",
    fill: "#0f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.38 282.05a132.29 132.29 0 0 1-2.264 1.151l-58.822-118.5z",
    fill: "#00ff8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.32 283.1a132.29 132.29 0 0 1-2.2837 1.1114l-56.745-119.5z",
    fill: "#00ff91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.24 284.11a132.29 132.29 0 0 1-2.3028 1.0713l-54.65-120.48z",
    fill: "#00ff95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.15 285.09a132.29 132.29 0 0 1-2.3211 1.031l-52.539-121.41z",
    fill: "#0f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.04 286.03a132.29 132.29 0 0 1-2.3387 0.99033l-50.412-122.31z",
    fill: "#00ff9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.92 286.93a132.29 132.29 0 0 1-2.3557 0.94937l-48.27-123.17z",
    fill: "#00ffa2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.78 287.79a132.29 132.29 0 0 1-2.3719 0.90811l-46.113-123.99z",
    fill: "#00ffa6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.62 288.62a132.29 132.29 0 0 1-2.3874 0.86657l-43.942-124.78z",
    fill: "#0fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.45 289.41a132.29 132.29 0 0 1-2.4021 0.82477l-41.758-125.53z",
    fill: "#00ffae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.27 290.16a132.29 132.29 0 0 1-2.4162 0.78273l-39.561-126.24z",
    fill: "#00ffb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.07 290.88a132.29 132.29 0 0 1-2.4294 0.74044l-37.351-126.91z",
    fill: "#00ffb7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.86 291.55a132.29 132.29 0 0 1-2.442 0.69793l-35.131-127.54z",
    fill: "#0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.65 292.19a132.29 132.29 0 0 1-2.4538 0.6552l-32.9-128.14z",
    fill: "#00ffbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.41 292.79a132.29 132.29 0 0 1-2.4649 0.61228l-30.658-128.69z",
    fill: "#00ffc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.17 293.34a132.29 132.29 0 0 1-2.4752 0.56917l-28.408-129.21z",
    fill: "#00ffc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.92 293.86a132.29 132.29 0 0 1-2.4847 0.52588l-26.148-129.68z",
    fill: "#0fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.67 294.34a132.29 132.29 0 0 1-2.4935 0.48243l-23.881-130.12z",
    fill: "#00ffd0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.4 294.78a132.29 132.29 0 0 1-2.5016 0.43885l-21.607-130.52z",
    fill: "#00ffd5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.13 295.19a132.29 132.29 0 0 1-2.5089 0.39512l-19.326-130.87z",
    fill: "#00ffd9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.85 295.55a132.29 132.29 0 0 1-2.5154 0.35127l-17.039-131.19z",
    fill: "#0fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.56 295.87a132.29 132.29 0 0 1-2.5211 0.30732l-14.746-131.47z",
    fill: "#00ffe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.27 296.15a132.29 132.29 0 0 1-2.5261 0.26327l-12.45-131.7z",
    fill: "#00ffe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.97 296.39a132.29 132.29 0 0 1-2.5303 0.21914l-10.149-131.9z",
    fill: "#00ffea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.67 296.59a132.29 132.29 0 0 1-2.5337 0.17495l-7.8458-132.06z",
    fill: "#0fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.37 296.75a132.29 132.29 0 0 1-2.5364 0.13071l-5.5398-132.18z",
    fill: "#00fff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.06 296.87a132.29 132.29 0 0 1-2.5383 0.0864l-3.2322-132.25z",
    fill: "#00fff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.75 296.95a132.29 132.29 0 0 1-2.5394 0.0421l-0.92357-132.29z",
    fill: "#00fffb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.45 296.99a132.29 132.29 0 0 1-2.5398-2e-3l1.3853-132.28z",
    fill: "#0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.14 296.99a132.29 132.29 0 0 1-2.5394-0.0465l3.6938-132.24z",
    fill: "#00fbff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.83 296.95a132.29 132.29 0 0 1-2.5382-0.0909l6.0012-132.16z",
    fill: "#00f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.52 296.87a132.29 132.29 0 0 1-2.5362-0.13514l8.3067-132.03z",
    fill: "#00f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.22 296.75a132.29 132.29 0 0 1-2.5334-0.17938l10.61-131.87z",
    fill: "#0ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.91 296.59a132.29 132.29 0 0 1-2.5299-0.22357l12.909-131.66z",
    fill: "#00eaff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.61 296.39a132.29 132.29 0 0 1-2.5256-0.26769l15.205-131.41z",
    fill: "#00e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.32 296.15a132.29 132.29 0 0 1-2.5206-0.31172l17.496-131.13z",
    fill: "#00e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.02 295.87a132.29 132.29 0 0 1-2.5148-0.35567l19.782-130.8z",
    fill: "#0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.74 295.55a132.29 132.29 0 0 1-2.5082-0.3995l22.062-130.44z",
    fill: "#00d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.46 295.19a132.29 132.29 0 0 1-2.5008-0.44321l24.335-130.03z",
    fill: "#00d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.18 294.78a132.29 132.29 0 0 1-2.4927-0.48678l26.601-129.59z",
    fill: "#00d0ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.92 294.34a132.29 132.29 0 0 1-2.4838-0.53022l28.859-129.11z",
    fill: "#0cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.66 293.86a132.29 132.29 0 0 1-2.4742-0.57349l31.107-128.58z",
    fill: "#00c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.41 293.34a132.29 132.29 0 0 1-2.4638-0.61658l33.347-128.02z",
    fill: "#00c4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.168 292.79a132.29 132.29 0 0 1-2.4527-0.65949l35.576-127.42z",
    fill: "#00bfff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.938 292.19a132.29 132.29 0 0 1-2.4408-0.70219l37.794-126.78z",
    fill: "#0bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.719 291.55a132.29 132.29 0 0 1-2.4282-0.74468l40.001-126.1z",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.511 290.88a132.29 132.29 0 0 1-2.4148-0.78695l42.196-125.38z",
    fill: "#00b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.315 290.16a132.29 132.29 0 0 1-2.4007-0.82897l44.377-124.63z",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.132 289.41a132.29 132.29 0 0 1-2.3859-0.87074l46.546-123.83z",
    fill: "#0af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.962 288.62a132.29 132.29 0 0 1-2.3703-0.91224l48.7-123z",
    fill: "#00a6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.807 287.79a132.29 132.29 0 0 1-2.354-0.95347l50.839-122.13z",
    fill: "#00a2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.666 286.93a132.29 132.29 0 0 1-2.337-0.99441l52.963-121.23z",
    fill: "#009dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.54 286.03a132.29 132.29 0 0 1-2.3193-1.035l55.07-120.28z",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.431 285.09a132.29 132.29 0 0 1-2.3009-1.0754l57.161-119.3z",
    fill: "#0095ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.339 284.11a132.29 132.29 0 0 1-2.2818-1.1154l59.235-118.29z",
    fill: "#0091ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.263 283.1a132.29 132.29 0 0 1-2.262-1.155l61.29-117.24z",
    fill: "#008cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.206 282.05a132.29 132.29 0 0 1-2.2414-1.1943l63.327-116.15z",
    fill: "#08f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.168 280.97a132.29 132.29 0 0 1-2.2203-1.2332l65.344-115.03z",
    fill: "#0084ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.148 279.85a132.29 132.29 0 0 1-2.1984-1.2718l67.342-113.87z",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.149 278.69a132.29 132.29 0 0 1-2.1759-1.31l69.319-112.68z",
    fill: "#007bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.169 277.51a132.29 132.29 0 0 1-2.1527-1.3478l71.275-111.45z",
    fill: "#07f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.211 276.28a132.29 132.29 0 0 1-2.1288-1.3851l73.209-110.19z",
    fill: "#0072ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.275 275.02a132.29 132.29 0 0 1-2.1043-1.4221l75.121-108.89z",
    fill: "#006fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.361 273.73a132.29 132.29 0 0 1-2.0792-1.4586l77.01-107.57z",
    fill: "#006aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.47 272.41a132.29 132.29 0 0 1-2.0534-1.4946l78.876-106.21z",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.602 271.05a132.29 132.29 0 0 1-2.027-1.5302l80.717-104.81z",
    fill: "#0062ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.758 269.66a132.29 132.29 0 0 1-2-1.5654l82.534-103.39z",
    fill: "#005eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.938 268.24a132.29 132.29 0 0 1-1.9724-1.6001l84.326-101.93z",
    fill: "#0059ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.144 266.79a132.29 132.29 0 0 1-1.9442-1.6342l86.092-100.45z",
    fill: "#05f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.375 265.3a132.29 132.29 0 0 1-1.9153-1.6679l87.832-98.927z",
    fill: "#0051ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.633 263.79a132.29 132.29 0 0 1-1.8859-1.7011l89.545-97.38z",
    fill: "#004dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.917 262.24a132.29 132.29 0 0 1-1.856-1.7338l91.231-95.802z",
    fill: "#0048ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.228 260.67a132.29 132.29 0 0 1-1.8254-1.7659l92.889-94.195z",
    fill: "#04f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.567 259.07a132.29 132.29 0 0 1-1.7943-1.7975l94.519-92.56z",
    fill: "#0040ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.935 257.43a132.29 132.29 0 0 1-1.7627-1.8285l96.12-90.896z",
    fill: "#003cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.331 255.77a132.29 132.29 0 0 1-1.7305-1.859l97.691-89.205z",
    fill: "#0037ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.756 254.08a132.29 132.29 0 0 1-1.6978-1.8889l99.233-87.486z",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.211 252.37a132.29 132.29 0 0 1-1.6646-1.9182l100.75-85.741z",
    fill: "#002fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.696 250.62a132.29 132.29 0 0 1-1.6308-1.947l102.23-83.97z",
    fill: "#002bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.212 248.86a132.29 132.29 0 0 1-1.5966-1.9752l103.68-82.173z",
    fill: "#0026ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.759 247.06a132.29 132.29 0 0 1-1.5619-2.0027l105.09-80.351z",
    fill: "#02f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.338 245.24a132.29 132.29 0 0 1-1.5267-2.0297l106.48-78.504z",
    fill: "#001eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.948 243.4a132.29 132.29 0 0 1-1.491-2.056l107.83-76.634z",
    fill: "#001aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.591 241.53a132.29 132.29 0 0 1-1.4549-2.0817l109.16-74.74z",
    fill: "#0015ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.267 239.64a132.29 132.29 0 0 1-1.4184-2.1068l110.44-72.824z",
    fill: "#01f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.976 237.72a132.29 132.29 0 0 1-1.3814-2.1312l111.7-70.885z",
    fill: "#000dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.718 235.79a132.29 132.29 0 0 1-1.344-2.155l112.92-68.925z",
    fill: "#0009ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.494 233.83a132.29 132.29 0 0 1-1.3062-2.1782l114.1-66.944z",
    fill: "#0004ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.305 231.85a132.29 132.29 0 0 1-1.268-2.2006l115.25-64.942z",
    fill: "#00f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.151 229.85a132.29 132.29 0 0 1-1.2294-2.2224l116.37-62.921z",
    fill: "#0400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.031 227.83a132.29 132.29 0 0 1-1.1904-2.2435l117.45-60.881z",
    fill: "#0900ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.948 225.79a132.29 132.29 0 0 1-1.1511-2.264l118.5-58.822z",
    fill: "#0d00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.899 223.74a132.29 132.29 0 0 1-1.1114-2.2837l119.5-56.745z",
    fill: "#10f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.887 221.66a132.29 132.29 0 0 1-1.0713-2.3028l120.48-54.65z",
    fill: "#1500ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.911 219.57a132.29 132.29 0 0 1-1.031-2.3211l121.41-52.539z",
    fill: "#1a00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.972 217.46a132.29 132.29 0 0 1-0.99033-2.3387l122.31-50.412z",
    fill: "#1e00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.07 215.33a132.29 132.29 0 0 1-0.94936-2.3557l123.17-48.27z",
    fill: "#20f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2052 213.19a132.29 132.29 0 0 1-0.9081-2.3719l123.99-46.113z",
    fill: "#2600ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.3777 211.04a132.29 132.29 0 0 1-0.86657-2.3874l124.78-43.942z",
    fill: "#2b00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5881 208.87a132.29 132.29 0 0 1-0.82478-2.4021l125.53-41.758z",
    fill: "#2f00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.8364 206.69a132.29 132.29 0 0 1-0.78273-2.4162l126.24-39.561z",
    fill: "#30f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.1229 204.49a132.29 132.29 0 0 1-0.74044-2.4295l126.91-37.351z",
    fill: "#3700ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.4478 202.28a132.29 132.29 0 0 1-0.69793-2.442l127.54-35.131z",
    fill: "#3c00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.8114 200.06a132.29 132.29 0 0 1-0.6552-2.4538l128.14-32.9z",
    fill: "#4000ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.2138 197.83a132.29 132.29 0 0 1-0.61228-2.4649l128.69-30.658z",
    fill: "#40f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.6552 195.59a132.29 132.29 0 0 1-0.56917-2.4752l129.21-28.408z",
    fill: "#4800ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.1358 193.34a132.29 132.29 0 0 1-0.52588-2.4847l129.68-26.148z",
    fill: "#4d00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.6558 191.08a132.29 132.29 0 0 1-0.48244-2.4935l130.12-23.881z",
    fill: "#5100ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.2152 188.82a132.29 132.29 0 0 1-0.43884-2.5016l130.52-21.607z",
    fill: "#50f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.8143 186.54a132.29 132.29 0 0 1-0.39512-2.5088l130.87-19.326z",
    fill: "#5900ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.4531 184.26a132.29 132.29 0 0 1-0.35127-2.5154l131.19-17.039z",
    fill: "#5e00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.1318 181.98a132.29 132.29 0 0 1-0.30732-2.5211l131.47-14.746z",
    fill: "#6200ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.85039 179.68a132.29 132.29 0 0 1-0.26327-2.5261l131.7-12.45z",
    fill: "#60f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.60905 177.39a132.29 132.29 0 0 1-0.21915-2.5303l131.9-10.149z",
    fill: "#6a00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.40781 175.09a132.29 132.29 0 0 1-0.17496-2.5338l132.06-7.8457z",
    fill: "#6f00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.24675 172.78a132.29 132.29 0 0 1-0.13071-2.5364l132.18-5.5398z",
    fill: "#7300ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.12591 170.48a132.29 132.29 0 0 1-0.086422-2.5383l132.25-3.2322z",
    fill: "#70f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.045333 168.17a132.29 132.29 0 0 1-0.042109-2.5394l132.29-0.92357z",
    fill: "#7b00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.0050373 165.86a132.29 132.29 0 0 1 0.0022163-2.5398l132.28 1.3853z",
    fill: "#8000ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.0050373 163.55a132.29 132.29 0 0 1 0.046541-2.5394l132.24 3.6938z",
    fill: "#8400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.045333 161.25a132.29 132.29 0 0 1 0.090852-2.5382l132.16 6.0012z",
    fill: "#80f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.12591 158.94a132.29 132.29 0 0 1 0.13513-2.5362l132.03 8.3067z",
    fill: "#8c00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.24675 156.63a132.29 132.29 0 0 1 0.17938-2.5334l131.87 10.61z",
    fill: "#9100ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.40781 154.33a132.29 132.29 0 0 1 0.22356-2.5299l131.66 12.909z",
    fill: "#9500ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.60905 152.03a132.29 132.29 0 0 1 0.26768-2.5256l131.41 15.205z",
    fill: "#90f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.85039 149.73a132.29 132.29 0 0 1 0.31172-2.5206l131.13 17.496z",
    fill: "#9d00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.1318 147.44a132.29 132.29 0 0 1 0.35566-2.5148l130.8 19.782z",
    fill: "#a200ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.4531 145.15a132.29 132.29 0 0 1 0.3995-2.5082l130.44 22.062z",
    fill: "#a600ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.8143 142.87a132.29 132.29 0 0 1 0.44321-2.5008l130.03 24.335z",
    fill: "#a0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.2152 140.6a132.29 132.29 0 0 1 0.48679-2.4927l129.59 26.601z",
    fill: "#ae00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.6558 138.33a132.29 132.29 0 0 1 0.53022-2.4838l129.11 28.859z",
    fill: "#b300ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.1358 136.08a132.29 132.29 0 0 1 0.57348-2.4742l128.58 31.107z",
    fill: "#b700ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.6552 133.83a132.29 132.29 0 0 1 0.61658-2.4638l128.02 33.347z",
    fill: "#b0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.2138 131.59a132.29 132.29 0 0 1 0.65948-2.4527l127.42 35.576z",
    fill: "#bf00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.8114 129.35a132.29 132.29 0 0 1 0.70219-2.4408l126.78 37.794z",
    fill: "#c400ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.4478 127.14a132.29 132.29 0 0 1 0.74468-2.4282l126.1 40.001z",
    fill: "#c800ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.1229 124.93a132.29 132.29 0 0 1 0.78694-2.4148l125.38 42.196z",
    fill: "#c0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.8364 122.73a132.29 132.29 0 0 1 0.82897-2.4007l124.63 44.377z",
    fill: "#d000ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5881 120.55a132.29 132.29 0 0 1 0.87074-2.3858l123.83 46.546z",
    fill: "#d500ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.3777 118.38a132.29 132.29 0 0 1 0.91224-2.3703l123 48.7z",
    fill: "#d900ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2052 116.22a132.29 132.29 0 0 1 0.95348-2.354l122.13 50.839z",
    fill: "#d0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.07 114.08a132.29 132.29 0 0 1 0.99442-2.337l121.23 52.963z",
    fill: "#e100ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.972 111.96a132.29 132.29 0 0 1 1.035-2.3193l120.28 55.07z",
    fill: "#e600ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.911 109.85a132.29 132.29 0 0 1 1.0754-2.3009l119.3 57.161z",
    fill: "#ea00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.887 107.76a132.29 132.29 0 0 1 1.1154-2.2818l118.29 59.235z",
    fill: "#e0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.899 105.68a132.29 132.29 0 0 1 1.155-2.262l117.24 61.29z",
    fill: "#f200ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.948 103.62a132.29 132.29 0 0 1 1.1943-2.2414l116.15 63.327z",
    fill: "#f700ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.031 101.58a132.29 132.29 0 0 1 1.2332-2.2203l115.03 65.344z",
    fill: "#fb00ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.151 99.565a132.29 132.29 0 0 1 1.2718-2.1984l113.87 67.342z",
    fill: "#f0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.305 97.565a132.29 132.29 0 0 1 1.31-2.1759l112.68 69.319z",
    fill: "#ff00fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.494 95.586a132.29 132.29 0 0 1 1.3478-2.1527l111.45 71.275z",
    fill: "#ff00f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.718 93.628a132.29 132.29 0 0 1 1.3851-2.1288l110.19 73.209z",
    fill: "#ff00f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.976 91.692a132.29 132.29 0 0 1 1.4221-2.1043l108.89 75.121z",
    fill: "#f0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.267 89.778a132.29 132.29 0 0 1 1.4586-2.0792l107.57 77.01z",
    fill: "#ff00ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.591 87.886a132.29 132.29 0 0 1 1.4946-2.0534l106.21 78.876z",
    fill: "#ff00e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.948 86.018a132.29 132.29 0 0 1 1.5303-2.027l104.81 80.717z",
    fill: "#ff00e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.338 84.174a132.29 132.29 0 0 1 1.5654-2l103.39 82.534z",
    fill: "#f0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.759 82.355a132.29 132.29 0 0 1 1.6001-1.9724l101.93 84.326z",
    fill: "#ff00d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.212 80.56a132.29 132.29 0 0 1 1.6342-1.9442l100.45 86.092z",
    fill: "#ff00d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.696 78.792a132.29 132.29 0 0 1 1.6679-1.9153l98.927 87.832z",
    fill: "#ff00d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.211 77.049a132.29 132.29 0 0 1 1.7011-1.8859l97.38 89.545z",
    fill: "#f0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.756 75.333a132.29 132.29 0 0 1 1.7337-1.856l95.802 91.231z",
    fill: "#ff00c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.331 73.645a132.29 132.29 0 0 1 1.7659-1.8254l94.195 92.889z",
    fill: "#ff00c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.935 71.984a132.29 132.29 0 0 1 1.7975-1.7943l92.56 94.519z",
    fill: "#ff00bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.567 70.351a132.29 132.29 0 0 1 1.8285-1.7627l90.896 96.12z",
    fill: "#f0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.228 68.747a132.29 132.29 0 0 1 1.859-1.7305l89.205 97.691z",
    fill: "#ff00b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.917 67.173a132.29 132.29 0 0 1 1.8889-1.6978l87.486 99.233z",
    fill: "#ff00b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.633 65.628a132.29 132.29 0 0 1 1.9183-1.6646l85.741 100.75z",
    fill: "#ff00ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.375 64.113a132.29 132.29 0 0 1 1.947-1.6308l83.97 102.23z",
    fill: "#f0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.144 62.629a132.29 132.29 0 0 1 1.9752-1.5966l82.173 103.68z",
    fill: "#ff00a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.938 61.176a132.29 132.29 0 0 1 2.0027-1.5619l80.351 105.09z",
    fill: "#ff00a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.758 59.754a132.29 132.29 0 0 1 2.0297-1.5267l78.504 106.48z",
    fill: "#ff009d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.602 58.365a132.29 132.29 0 0 1 2.056-1.491l76.634 107.83z",
    fill: "#f09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.47 57.008a132.29 132.29 0 0 1 2.0817-1.4549l74.74 109.16z",
    fill: "#ff0095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.361 55.683a132.29 132.29 0 0 1 2.1068-1.4184l72.824 110.44z",
    fill: "#ff0091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.275 54.392a132.29 132.29 0 0 1 2.1312-1.3814l70.885 111.7z",
    fill: "#ff008c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.211 53.135a132.29 132.29 0 0 1 2.155-1.344l68.925 112.92z",
    fill: "#f08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.169 51.911a132.29 132.29 0 0 1 2.1782-1.3062l66.944 114.1z",
    fill: "#ff0084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.149 50.722a132.29 132.29 0 0 1 2.2006-1.268l64.942 115.25z",
    fill: "#ff0080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.148 49.568a132.29 132.29 0 0 1 2.2224-1.2294l62.921 116.37z",
    fill: "#ff007b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.168 48.448a132.29 132.29 0 0 1 2.2435-1.1904l60.881 117.45z",
    fill: "#f07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.206 47.364a132.29 132.29 0 0 1 2.264-1.1511l58.822 118.5z",
    fill: "#ff0073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.263 46.316a132.29 132.29 0 0 1 2.2837-1.1114l56.745 119.5z",
    fill: "#ff006f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.339 45.304a132.29 132.29 0 0 1 2.3028-1.0713l54.65 120.48z",
    fill: "#ff006a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.431 44.328a132.29 132.29 0 0 1 2.3211-1.031l52.539 121.41z",
    fill: "#f06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.54 43.389a132.29 132.29 0 0 1 2.3387-0.99033l50.412 122.31z",
    fill: "#ff0062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.666 42.487a132.29 132.29 0 0 1 2.3557-0.94936l48.27 123.17z",
    fill: "#ff005e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.807 41.622a132.29 132.29 0 0 1 2.3719-0.9081l46.113 123.99z",
    fill: "#ff0059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.962 40.794a132.29 132.29 0 0 1 2.3874-0.86657l43.942 124.78z",
    fill: "#f05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.132 40.005a132.29 132.29 0 0 1 2.4021-0.82477l41.758 125.53z",
    fill: "#ff0051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.315 39.253a132.29 132.29 0 0 1 2.4162-0.78272l39.561 126.24z",
    fill: "#ff004d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.511 38.54a132.29 132.29 0 0 1 2.4294-0.74044l37.351 126.91z",
    fill: "#ff0048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.719 37.864a132.29 132.29 0 0 1 2.442-0.69793l35.131 127.54z",
    fill: "#f04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.938 37.228a132.29 132.29 0 0 1 2.4538-0.6552l32.9 128.14z",
    fill: "#ff0040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.168 36.63a132.29 132.29 0 0 1 2.4649-0.61228l30.658 128.69z",
    fill: "#ff003c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.41 36.072a132.29 132.29 0 0 1 2.4752-0.56917l28.408 129.21z",
    fill: "#ff0037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.66 35.552a132.29 132.29 0 0 1 2.4847-0.52588l26.148 129.68z",
    fill: "#f03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.92 35.072a132.29 132.29 0 0 1 2.4935-0.48244l23.881 130.12z",
    fill: "#ff002f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.18 34.632a132.29 132.29 0 0 1 2.5016-0.43884l21.607 130.52z",
    fill: "#ff002b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.46 34.231a132.29 132.29 0 0 1 2.5088-0.39512l19.326 130.87z",
    fill: "#ff0026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.74 33.87a132.29 132.29 0 0 1 2.5154-0.35127l17.039 131.19z",
    fill: "#f02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.02 33.548a132.29 132.29 0 0 1 2.5211-0.30732l14.746 131.47z",
    fill: "#ff001e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.32 33.267a132.29 132.29 0 0 1 2.5261-0.26327l12.45 131.7z",
    fill: "#ff001a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.61 33.026a132.29 132.29 0 0 1 2.5303-0.21915l10.149 131.9z",
    fill: "#ff0015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.91 32.824a132.29 132.29 0 0 1 2.5337-0.17496l7.8457 132.06z",
    fill: "#f01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.22 32.663a132.29 132.29 0 0 1 2.5364-0.13071l5.5398 132.18z",
    fill: "#ff000d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.52 32.543a132.29 132.29 0 0 1 2.5383-0.08642l3.2322 132.25z",
    fill: "#ff0009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.83 32.462a132.29 132.29 0 0 1 2.5394-0.04211l0.92356 132.29z",
    fill: "#ff0004"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.29,
    cy: 164.71,
    r: 132.29,
    fill: "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbowSwatchIcon);
export default __webpack_public_path__ + "static/media/rainbow_swatch_icon.d27b9cdcf0290ae9fff0d518f0ef6317.svg";
export { ForwardRef as ReactComponent };